import { forwardRef, type ReactNode } from "react";
import { cn } from "@/lib/utils";
import { WhatsAppMockDatePill, waChatBackgroundStyle } from "./WhatsAppMockChrome";

type WhatsAppMockMessageListProps = {
  children: ReactNode;
  className?: string;
  scrollClassName?: string;
  contentClassName?: string;
};

/** Área de mensagens com pill “Hoje”, fundo WA e espaço preenchido acima das bolhas. */
export const WhatsAppMockMessageList = forwardRef<HTMLDivElement, WhatsAppMockMessageListProps>(
  function WhatsAppMockMessageList(
    { children, className, scrollClassName, contentClassName },
    ref,
  ) {
    return (
      <div
        ref={ref}
        className={cn("use-case-chat-scroll min-h-0 flex-1 overflow-y-auto", scrollClassName)}
        style={waChatBackgroundStyle}
      >
        <div
          className={cn(
            "flex min-h-full flex-col justify-end gap-1.5 px-2.5 pb-1 pt-1",
            className,
            contentClassName,
          )}
        >
          <div className="flex shrink-0 justify-center py-1">
            <WhatsAppMockDatePill />
          </div>
          {children}
        </div>
      </div>
    );
  },
);
